import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import CityPanelItem from './city-panel-item';
import NoData from './no-data';

var CityList = function CityList(props) {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var groupKeys = props.groupKeys,
      cityList = props.cityList,
      handleSelect = props.onSelect;
  var cityPickerPrefixCls = getPrefixCls(prefixCls, 'city-picker');
  var tableCls = classNames("".concat(cityPickerPrefixCls, "-city-table"));
  var tableGroupCls = classNames("".concat(cityPickerPrefixCls, "-city-table-group"));
  var keyCls = classNames("".concat(cityPickerPrefixCls, "-city-table-key"));
  var itemContainerCls = classNames("".concat(cityPickerPrefixCls, "-city-table-item-container"));
  var hasData = cityList && cityList.some(function (citys) {
    return citys.length > 0;
  });

  if (!hasData) {
    return /*#__PURE__*/React.createElement("div", {
      className: tableCls
    }, /*#__PURE__*/React.createElement(NoData, null));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: tableCls
  }, groupKeys && groupKeys.length > 0 && _mapInstanceProperty(groupKeys).call(groupKeys, function (key, index) {
    var list = cityList[index] || [];
    return /*#__PURE__*/React.createElement("div", {
      className: tableGroupCls,
      key: key
    }, /*#__PURE__*/React.createElement("div", {
      className: keyCls
    }, key), /*#__PURE__*/React.createElement("div", {
      className: itemContainerCls
    }, _mapInstanceProperty(list).call(list, function (city) {
      return /*#__PURE__*/React.createElement(CityPanelItem, {
        key: city.id,
        city: city,
        onSelect: handleSelect
      });
    })));
  }), !groupKeys && cityList && _mapInstanceProperty(cityList).call(cityList, function (citys) {
    return _mapInstanceProperty(citys).call(citys, function (city) {
      return /*#__PURE__*/React.createElement(CityPanelItem, {
        key: city.id,
        city: city,
        onSelect: handleSelect
      });
    });
  }));
};

export default CityList;